import { closeActivePopup } from "@client/actions";
import { type PopupProps } from "@client/layout/Popup/container";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeOverlayStyleSelector, makeStyleSelector } from "./selectors";

type Props = PopupProps;
const makeMapStateToProps = () => {
  const overlayStyleSelector = makeOverlayStyleSelector();
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: Props): MapProps => {
    return {
      ...props,
      keepOpenOnOverlayClick: props.keepOpenOnOverlayClick ?? false,
      overlayStyle: overlayStyleSelector(state, props),
      style: styleSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any): ActionProps => ({
  close: () => dispatch(closeActivePopup())
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
